module.exports = __webpack_public_path__ + "img/icon-reload.398503c6.svg";